export default __webpack_public_path__ + "static/media/attraction5.2e6e1652.jpg";